// Config & Constants
import { APPLICATION_CONSTANTS, PATHS } from '../AppConstants';

// API Setup
import { getccbAxiosConfig } from '../apisSetup/ccbConfig';

const axiosApiCaller = getccbAxiosConfig(PATHS.CCB_URL, { 'os': APPLICATION_CONSTANTS.DEVICE_TYPE }, false);

export const getDashboardContacts = () => axiosApiCaller.get(PATHS.CORP_SUPPORT_CONTACTS);

